import { StackProps, Stack } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { BannerBox } from "components/molecules/BannerBox";
import React, { FC, memo } from "react";
import { firstValueFrom } from "rxjs";
import { bannerService } from "services/bannerService";

export const BannerList: FC = memo((props: StackProps) => {

  const { data: banners } = useQuery({
    queryKey: ["banners"],
    queryFn: async () => {
      return await firstValueFrom(bannerService.get$);
    }
  })
  return !!banners?.items?.length && (
    <Stack gap={1} mb={2} {...props} >
      {banners.items.map((banner) => (
        <BannerBox banner={banner} />
      ))}
    </Stack>
  );
});